import { useTranslation } from 'react-i18next';
import { ChevronLeftIcon, PencilIcon } from '@utils/icons';
import { Tooltip } from '@components/ui/Tooltip/Tooltip';
import type { AnnotationsBlocker } from '../annotations.url';
import styles from './AnnotationsHeader.module.css';

interface IAnnotationsHeaderProps {
  docName: string;
  version: number | null;
  onBack: () => void;
  /** Locked while a save is in flight — leaving then would contradict the save. */
  backDisabled?: boolean;
  onAnnotate?: () => void;
  /** Why drawing is not available yet, if it isn't — shown on the disabled
   *  button, so "nothing happens when I click it" is never the whole story. */
  annotateBlockedBy?: AnnotationsBlocker | null;
}

export function AnnotationsHeader({
  docName, version, onBack, backDisabled = false, onAnnotate, annotateBlockedBy = null,
}: IAnnotationsHeaderProps) {
  const { t } = useTranslation();
  return (
    <header className={styles.bar}>
      <button type="button" className={styles.back} onClick={onBack} disabled={backDisabled} aria-label={t('documents.annotations.back')}>
        <ChevronLeftIcon size={16} />
      </button>
      <div className={styles.names}>
        <h1 className={styles.docName}>{docName}</h1>
        {version !== null && (
          <span className={styles.version}>{t('documents.annotations.version', { version })}</span>
        )}
      </div>
      <div className={styles.spacer} />
      {onAnnotate && (
        <Tooltip content={annotateBlockedBy ? t(`documents.annotations.blocked.${annotateBlockedBy}`) : ''}>
          <span className={styles.annotateAnchor}>
            <button type="button" className={styles.annotate} onClick={onAnnotate} disabled={annotateBlockedBy !== null}>
              <PencilIcon size={15} />
              {t('documents.annotations.annotate')}
            </button>
          </span>
        </Tooltip>
      )}
    </header>
  );
}
